import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import WorkingOnIt from '../../assets/images/svg-icons-material-io/downloading_FILL0_wght400_GRAD0_opsz48.svg';
import $ from "jquery";

const UploadProgressModal = () => {
    let navigate = useNavigate();
    const routeUploadStatus = () => {
        let path = '/upload-status';
        navigate(path);
        CloseModal();
    }
    const firstFocusRef = useRef(null);

    useEffect(() => {
        const modalEl = document.getElementById("uploadProgressModal");
        if (!modalEl) return;
        const onShown = () => setTimeout(() => firstFocusRef.current?.focus(), 50);
        modalEl.addEventListener("shown.bs.modal", onShown);
        return () => modalEl.removeEventListener("shown.bs.modal", onShown);
    }, []);

    const CloseModal = () => {
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
        $('#uploadProgressModal').modal('hide');
    };
    return (
        <div className="Upload">
            <div
                className="modal fade"
                id="uploadProgressModal"
                data-backdrop="static"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="upload-progress-title"
                aria-describedby="uploadProgressModalDesc"
                aria-modal="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3 className="modal-title spacer-inline" id="upload-progress-title">
                                Upload Progress
                            </h3>
                            <button
                                type="button"
                                className="close"
                                aria-label="Close upload progress modal"
                                onClick={CloseModal}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p id="uploadProgressModalDesc" className="sr-only">
                                Your file has been queued for upload. You can check the status
                                on the Upload Status page.
                            </p>
                            <div className="ctr">
                                <img
                                    src={WorkingOnIt}
                                    className="w-md1 filter-orange rotate-up"
                                    aria-hidden="true"
                                    alt=""
                                />
                                <p className="field-wrapper sp-margin3">
                                    <strong>We're working on it...</strong>
                                </p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-success"
                                aria-label="Go to Upload Status page"
                                onClick={routeUploadStatus}
                            >
                                Upload Status
                            </button>
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={CloseModal}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UploadProgressModal;
